import { ItemOffer } from "@/types";

/**
 * Filters item offers whose item NAME contains the term (case-insensitive).
 *
 * `itemNames` maps item name -> item id. Matching ids are collected into a
 * Set first so the term is only ever compared against names — the previous
 * `Object.entries(...).flat()` variant could accidentally match an itemId
 * against the name list.
 *
 * Callers keep their own empty-term semantics (return [] vs all offers).
 */
export function filterItemOffersByName(
  itemOffers: ItemOffer[],
  itemNames: Record<string, string>,
  filter: string,
): ItemOffer[] {
  const term = filter.toUpperCase();
  const matchingItemIds = new Set(
    Object.entries(itemNames)
      .filter(([name]) => name.toUpperCase().includes(term))
      .map(([, id]) => id),
  );
  return itemOffers.filter((io) => matchingItemIds.has(io.itemId));
}
